import type mdast from 'mdast';
import { gfmStrikethroughToMarkdown } from 'mdast-util-gfm-strikethrough';
import { Options } from 'remark-stringify';
import { Plugin } from 'unified';

type MarkdownProcessorData = Record<string, unknown> & {
  toMarkdownExtensions?: Options[];
};

/**
 * Remark plugin that stringifies deletes a.k.a. strikethroughs.
 *
 * This is pared-down version of remarkGfm, because the full version escapes URLs.
 */
export const stringifyStrikethrough: Plugin<[], mdast.Root> = function plugin() {
  const data = this.data() as MarkdownProcessorData;
  data.toMarkdownExtensions ||= [];
  data.toMarkdownExtensions.push(gfmStrikethroughToMarkdown);
};
